import React, { useCallback, useEffect, useState } from 'react'
import OverlayRight, { StyledOverlayInnerWrapper } from '../../Page/logix2020/OverlayRight'
import OverlayContainer from '../../Page/logix2020/OverlayContainer'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { useTranslation } from 'react-i18next'
import { ExcelButton } from '../../Buttons/ExcelButton'
import StatisticOverTimePeriod from './StatisticOverTimePeriod'
import StatisticPartsInWashingProcess from './StatisticPartsInWashingProcess'
import StatisticSortedOutRFIDs from './StatisticSortedOutRFIDs'
import StatisticForSingleRFID from './StatisticForSingleRFID'
import StatisticRFIDs from './StatisticRFIDs'

import { Alert } from 'react-bootstrap'
import ReportSubscriptionModal from '../../Files/Form/ReportSubscriptionModal'
import useReport from '../../../utils/hooks/useReport'
import DownloadURLAlert from '../../Forms/DownloadURLAlert'
import { emptyGuid } from '../../../utils/emptyGuid'


const WashCreateNewReportContent = ({ reportTypeId, reportTypeName, preSelectedData }) => {
  const { t } = useTranslation()
  const [formData, setFormData] = useState({})
  const { createReport, reportIsLoading, setReportIsLoading, reportDownloadUrls, reportErrors, setReportErrors, setReportDownloadUrls, reportIsSendByMail, setReportIsSendByMail, reportSubscriptionId, setReportSubscriptionId } = useReport()

  useEffect(() => {
    //clear form State when reselect
    setReportErrors({})
    setFormData({})
    setReportSubscriptionId("")
    setReportIsLoading({})
    setReportDownloadUrls({})
    setReportIsSendByMail(false)
  }, [reportTypeId, setReportDownloadUrls, setReportErrors, setReportIsLoading, setReportIsSendByMail, setReportSubscriptionId])

  const handleClickCreateReport = useCallback(() => {
    let endpoint = ''
    switch (reportTypeId) {
      case 'statisticOverTimePeriod':
        endpoint = 'statisticOverTimePeriod'
        break
      case 'statisticForSingleRFID':
        endpoint = 'statisticForSingleRFID'
        break
      case 'statisticSortedOutRFIDs':
        endpoint = 'statisticSortedOutRFIDs'
        break
      case 'statisticPartsInWashingProcess':
        endpoint = 'statisticPartsInWashingProcess'
        break
      case 'RFIDs':
        endpoint = 'statisticRFIDs'
        break
      default:
    }

    if (endpoint === '') {
      console.log(`no api endpoint defined for reportTypeId "${reportTypeId}"`)
      return
    }

    createReport("reportName", APIEndpoints[endpoint], formData)
  }, [createReport, formData, reportTypeId])

  useEffect(() => {
    if (formData.targetCostcenterID === emptyGuid) {
      setFormData(prev => ({ ...prev, include_Subordinated_CostCenters: true }))
    }
    if (formData.officeID === emptyGuid) {
      setFormData(prev => ({ ...prev, includeSubordinatedOffices: true }))
    }
  }, [setFormData, formData.targetCostcenterID, formData.officeID])

  return (
    <>
      <div className="content">
        <div className="data-list__name h2">{reportTypeName}</div>
        {reportTypeId === 'statisticOverTimePeriod' && (
          <StatisticOverTimePeriod formData={formData} setFormData={setFormData} formErrors={reportErrors?.reportName?.formErrors} />
        )}
        {reportTypeId === 'statisticForSingleRFID' && (
          <StatisticForSingleRFID formData={formData} setFormData={setFormData} formErrors={reportErrors?.reportName?.formErrors} />
        )}
        {reportTypeId === 'statisticSortedOutRFIDs' && (
          <StatisticSortedOutRFIDs formData={formData} setFormData={setFormData} formErrors={reportErrors?.reportName?.formErrors} />
        )}
        {reportTypeId === 'statisticPartsInWashingProcess' && (
          <StatisticPartsInWashingProcess formData={formData} setFormData={setFormData} formErrors={reportErrors?.reportName?.formErrors} />
        )}
        {reportTypeId === 'RFIDs' && (
          <StatisticRFIDs formData={formData} setFormData={setFormData} formErrors={reportErrors?.reportName?.formErrors} />
        )}
        {reportErrors.reportName && (
          <Alert variant="danger">
            <strong>{reportErrors.reportName.value}</strong><br />
            {/*{error}*/}
          </Alert>
        )}
        {reportDownloadUrls.reportName && <DownloadURLAlert
          downloadUrl={reportDownloadUrls.reportName}
          setDownloadUrl={() => setReportDownloadUrls({})}
          fileName={reportTypeId}
        />}

        {reportIsSendByMail && (
          <Alert variant="success">
            {t('reportConfig:isSendByMail')}
          </Alert>
        )}

        {reportSubscriptionId && <ReportSubscriptionModal
          reportSubscriptionId={reportSubscriptionId}
          setReportSubscriptionId={setReportSubscriptionId}
          message={t('reportConfig:createPending')}

        />}

      </div>
      <div className="footer p-4" >
        <ExcelButton
          className="w-100"
          isLoading={reportIsLoading.reportName}
          onClick={handleClickCreateReport}
          loadingText={`${t('reports:createExcelReport')}...`}
          buttonText={t('reports:createExcelReport')} />
      </div>
    </>
  )
}

const WashCreateNewReportOverlay = ({ visible, onClose, ...rest }) => {
  const { t } = useTranslation()

  return (
    <OverlayContainer>
      <OverlayRight visible={visible} onClose={onClose} headerTitle={t('reports:createNewReport')}>
        <StyledOverlayInnerWrapper>
          {visible && <WashCreateNewReportContent {...rest} />}
        </StyledOverlayInnerWrapper>
      </OverlayRight>
    </OverlayContainer>

  )
}

export default WashCreateNewReportOverlay
